import { defineStore } from 'pinia';

export const usePageStore = defineStore('page', {
  state: () => ({
    pageContent: null,
    pageId: null,
    pageMeta: null,
    pageHead: null,
    linkPdf: null,
    isLoading: true,
    error: null,
    footerPages: [],
  }),
  actions: {
    setPageContent(content) {
      this.pageContent = content;
    },
    setPageId(id) {
      this.pageId = id;
    },
    setLinkPdf(url) {
      this.linkPdf = url;
    },
    removeLinkPdf() {
      this.linkPdf = null;
    },
    setPageHead(head) {
      this.pageHead = head;
    },
    emptyPageContent() {
      this.pageContent = null;      
    },
    setLoading(loading) {
      this.isLoading = loading;
    },
    setError(error) {
      this.error = error;
    },
    setFooterPages(pages) {
      this.footerPages = pages;
    },
    async fetchFooterPages() {
      if (this.footerPages.length > 0) {
        return;
      }
      const config = useRuntimeConfig();
      try {
        const footerMenuUrl = `${config.public.wordpressApiUrl}/wp-json/wp/v2/menu/5`;
        const footerMenuResponse = await fetch(footerMenuUrl);
        if (!footerMenuResponse.ok) {
          throw new Error('Failed to fetch footer menu');
        }
        const footerMenuData = await footerMenuResponse.json();
        if (footerMenuData.length > 0) {
          this.footerPages = footerMenuData.map(item => ({
            ...item,
            path: item.url.replace(config.public.wordpressApiUrl.replace(/\/$/, '') + '/', '') || '/'
          }));
        }
      } catch (e) {
        console.error('Error fetching footer pages:', e);
      }
    },
  },
});